import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { PPFileDirectoryService } from 'app/services/pp-file-directory.service';

@Component({
  selector: 'app-confirm-disclaimer-dialog',
  templateUrl: './confirm-disclaimer-dialog.component.html',
  styleUrls: ['./confirm-disclaimer-dialog.component.scss']
})
export class ConfirmDisclaimerDialogComponent implements OnInit {

  termsConditions: boolean = false;
  ppFileName: string = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ConfirmDisclaimerDialogComponent>,
    private fuseProgressBar: FuseProgressBarService,
    private ppFileService: PPFileDirectoryService,
  ) {
  }

  ngOnInit(): void {
    this.ppFileName = this.data.ppFileName;
  }

  onCheckTermsConditions(e){
    this.termsConditions = e.checked;
  }

  onSave(){
    this.fuseProgressBar.show();
    this.ppFileService.acceptanceFile({ppFileId: this.data.ppFileId, userId: this.data.acceptanceUser})
    .subscribe(
      res => {
        this.fuseProgressBar.hide();
        this.dialogRef.close(true);
      },
      err => {
        console.log(err);
        this.fuseProgressBar.hide();
      }
    );
  }

}
